import React from "react";
import "./NameLogo.css";

interface NameLogoProps {
  text: string;
  id: string;
  size: number;
}

const NameLogo = ({text, id, size}: NameLogoProps) => {
  const random = id.split("-").map((hex) => Number("0x" + hex));

  return (
    <div className="nameLogo" style={{width: size + "px", height: size + "px"}}>
      <svg
        width={size}
        height={size}
        viewBox="0 0 128 128"
        fill="none"
        xmlns="http://www.w3.org/2000/svg"
        className="nameLogo__icon"
        aria-hidden
      >
        <rect
          x={0}
          y={0}
          width={128}
          height={128}
          rx={random[0] % 3 === 4 ? 0 : random[0] % 3 === 1 ? 16 : 64}
          ry={random[0] % 3 === 4 ? 0 : random[0] % 3 === 1 ? 16 : 64}
          fill={`hsl(${random[1] % 360} 70 75)`}
        />
      </svg>
      <div
        className={
          "nameLogo__text" + (size < 64 ? " nameLogo__text--small" : "")
        }
      >
        {text}
      </div>
    </div>
  );
};

export {NameLogo};
